"use strict";

exports.__esModule = true;
exports.initI18n = exports.DEFAULT_I18N_NS = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _createI18nConfig = _interopRequireDefault(require("./create-i18n-config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_I18N_NS = 'translation';
exports.DEFAULT_I18N_NS = DEFAULT_I18N_NS;

var initI18n = function initI18n(lng, localeData) {
  var _lng, _resources;

  return _i18next["default"].init(_objectSpread(_objectSpread({}, (0, _createI18nConfig["default"])()), {}, {
    resources: (_resources = {}, _resources[lng] = (_lng = {}, _lng[DEFAULT_I18N_NS] = localeData, _lng), _resources),
    lng: lng
  }));
};

exports.initI18n = initI18n;